import { get, post, put } from './request'

// ********************（员工管理）********************
// 获取员工列表
function getStaffList(params) {
  return get('/channel_admin/staffs', params)
}

// 创建员工发送验证码
function getStaffVerificationCode(data) {
  return post('/channel_admin/staff/create/send_message', data)
}

// 创建员工
function createStaff(data) {
  return post('/channel_admin/staffs', data)
}

// 修改员工状态
function changeStaffStatus(data) {
  return post('/channel_admin/staff_state', data)
}

// 修改员工角色
function changeStaffRole(data) {
  return post('/channel_admin/staffs/change_role', data)
}

// 查询管理员配置
function getAdminConfig(params) {
  return get('/channel_admin/channel_configs', params)
}

// 修改管理员配置
function changeAdminConfig(data) {
  return post('/channel_admin/channel_configs', data)
}
// 修改员工信息
function changeStaffInfoApi(data) {
  return put('/channel_admin/staffs', data)
}
// 获取员工下拉
function getStaffSelect(params) {
  return get('/channel_admin/staff/target', params)
}
function changeStaffApi(data) {
  return post('/channel_admin/staff/transfer/v2', data)
}
// 获取迁移客户的，客户列表
function getEnterprisers(data) {
  return get('/channel_admin/enterprisers', data)
}

// 获取授权配置信息
function getAuthConfigInfo(params) {
  return get('/channel_admin/config_staff_price', params)
}
// 修改授权配置信息
function updateAuthConfigInfo(data) {
  return post('/channel_admin/config_staff_price', data)
}

// 获取客户详情
function getCustomerDetailInfo(params) {
  return get('/channel_admin/customers/detail_info', params)
}
// 获取客户跟进详情
function getCustomerDetailFollowUpInfo(params) {
  return get('/channel_admin/customers/follow_up', params)
}

// 获取客户详情，客户状态，枚举值
function getCustomerStatusList(params) {
  return get('/channel_admin/customer_status_list', params)
}

// ********************（客户管理）********************
// 获取客户列表
function getCustomerList(params) {
  return get('/channel_admin/enterprisers', params)
}

// 修改客户状态
function changeCustomerStatus(data) {
  return post('/channel_admin/enterpriser_state', data)
}

// 获取邀请码
function requestInviteCode() {
  return get('/channel_admin/invite_code')
}

// 生成邀请码
function requestGenerateInviteCode(data) {
  return post('/channel_admin/invite_code', data)
}
// 短信通知查询
function getChannelSMS(params) {
  return get('/channel_admin/sms_inform_info', params)
}

// 发送短信检测通知
function sendChannelSMS(data) {
  return post('/channel_admin/sms_inform_info', data)
}

// 分配推广员工
function allocation(data) {
  return post('/channel_admin/enterpriser/allocation', data)
}

export {
  getAuthConfigInfo,
  updateAuthConfigInfo,
  getStaffList,
  getStaffVerificationCode,
  createStaff,
  changeStaffStatus,
  changeStaffRole,
  getAdminConfig,
  changeAdminConfig,
  getCustomerList,
  changeCustomerStatus,
  changeStaffInfoApi,
  getStaffSelect,
  changeStaffApi,
  getEnterprisers,
  requestInviteCode,
  requestGenerateInviteCode,
  getChannelSMS,
  sendChannelSMS,
  allocation,
  getCustomerDetailInfo,
  getCustomerDetailFollowUpInfo,
  getCustomerStatusList,
}
